import Papa from "papaparse"
import FileDownload from "js-file-download"

export const turnFileIntoBuffer = (file: File): Promise<Buffer> => {
	return new Promise<Buffer>((resolve, reject) => {
		const reader = new FileReader()

		reader.onabort = () => reject(new Error())
		reader.onerror = () => reject(new Error())

		reader.onload = () => {
			const arrayBuffer = reader.result as ArrayBuffer

			const buffer = Buffer.from(arrayBuffer)

			resolve(buffer)
		}

		reader.readAsArrayBuffer(file)
	})
}

export const downloadCsv = (headers: string[], rows: string[][], filename: string): void => {
	const csv = Papa.unparse({ fields: headers, data: rows })
	const blob = new Blob([csv], { type: "text/csv" })
	FileDownload(blob, filename)
}

export const turnFileIntoDataUrl = (file: File): Promise<string> => {
	return new Promise<string>((resolve, reject) => {
		const reader = new FileReader()

		reader.onabort = () => reject(new Error())
		reader.onerror = () => reject(new Error())

		reader.onload = () => {
			const dataURL = reader.result as string

			resolve(dataURL)
		}

		reader.readAsDataURL(file)
	})
}
